import React, { useState } from 'react';

import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";

import LoadingPanel from 'views/widgets/LoadingPanel.jsx';
import MessageDialog from 'views/widgets/MessageDialog.jsx';
import MfaDialog from 'views/login/MfaDialog.jsx';

import './styles.css';

export default function LoginView(props) {
	
	const { authenticatedCallback, loadPreferences } = props;


	const initialState = {
		masked: false,
		username: null,
		password: null,
		error: false,
		preferences: null
	};
	const [state, setState] = useState(initialState);
	
	const closeDialog = () => {
		setState({ ...state, mfaDialog: false });
	}
	
	const loadPreferencesFromState = () => {
		loadPreferences(state.preferences);
		setState({...state, preferences: null});
	}
	
	const mfaAuthorizeDeviceFailed = (message) => {
		setState({ ...state, masked: false, error: message });
	}

	// handle submission of the login form
	const handleSubmit = (e) => {
		e.preventDefault();	
		
		let data = new URLSearchParams();
		data.append('username', state.username);
		data.append('password', state.password);

		setState({ ...state, masked: true, mfaDialog: false });
		fetch(API_URL + "/perform_login", { 
			method: 'POST', 
			body: data,
			credentials: 'include'
		}).then(response => response.json()
			.then(data => ({ status: response.status, body: data }))
		).then((result) => {
				setState({ ...state, masked: false });
				if (result.status == 200 && !result.body.pendingMfa) {
//				if (result.status == 200) {
					loadPreferences(result.body);
					authenticatedCallback();
				} else if (result.status == 200 && result.body.pendingMfa) {
					//Need to store response in state so we can load preferences after mfa approval
					setState({...state, mfaDialog: true, preferences: result.body});
				} else if (result.status == 302) {
					moveToCustomLogin();
				} else if (result.status == 406) {
					throw new Error("Your user has no assigned roles.  Please contact your organization administrator.");

				} else if (!result.body.success) {
					if (result.body.message != null && result.body.message.length > 0 && result.body.locked) {
						throw new Error("Your account has been locked for excessive failed logins.  A reset password email has been sent to your email address.");
					} else {
						throw new Error("Please check your username and password.  If you still can't log in, contact your Constituo administrator");
					}

				} else {
					throw new Error("Please check your username and password.  If you still can't log in, contact your Constituo administrator");
				}
			}).catch((error) => {
				setState({ ...state, masked: false, error: error.message });
			});
	};
	
	const forgotPassword = () => {
		setState({...state, masked: true});
		if (!state.username) {
			setState({...state, masked: false, dialog: {title: 'Forgot Password', body: 'You must supply a valid user name.'}});
			return;
		}
		fetch(API_URL + "/public/forgot/pw?username=" + encodeURIComponent(state.username), {
			method: 'POST'
		}).then(function(response) {
			if(response.status == 405){
				throw Error("Not Allowed");
			}
			else if (!response.ok) {
				throw Error(response.statusText);
			} 
			return true;
		}).then(function() {
			setState({...state, masked: false, dialog: {title: 'Forgot Password', body: 'A request to reset your password has been sent.'} });
		}).catch(function(e) {
			var errorMsg = 'There was a problem sending the forgot password request.  Please try again.  If the problem persists, please contact support';
			if(e.message=="Not Allowed")
				errorMsg = "Constituo Authentication is not enabled for " + state.username;
			setState({...state, masked: false, dialog: {title: 'Forgot Password', body: errorMsg}});
		});
	};
	
	const moveToCustomLogin = () => {
		setState({...state, masked: true});
		if (!state.username) {
			setState({ ...state, masked: false, error: "Please enter your user email address to use Single Sign-On" });
		}else{
			fetch(API_URL + "/public/login/check/?username=" + encodeURIComponent(state.username), {
				method: 'GET'
			}).then(function(response) {
				if (response.ok) { return response.text(); }
				else { throw new Error(response.status); }
			}).then(function(userOrgCode) {
				if(userOrgCode!=null){
					let ssoLoginUrl = "./#/sso/" + userOrgCode;
					console.log(ssoLoginUrl);
					window.location = ssoLoginUrl;
				}else{
					throw new Exception("Failed to find organization code.");
				}
			}).catch(function() {
				setState({ ...state, masked: false, error: "Single Sign-On is not enabled for " + state.username });
			});	
		}
	};
	
	return (
		<div className='login-container'>
			<div id='content-container'>
				<div id='content-container-top-bar'>
					<div id='login-logo'><span id="logo-wheel" className="fa fa-cs-logo"/><span id="login-company-name" className="ubuntu">constituo</span><span id='name-registered-mark' className='fa fa-registered'></span></div>
				</div>
				<div id='content-logo-container'>
					<div id="slogan">Smarter and Faster Campus Processes</div>
					<div id="subslogan">Automate your campus in a new, simplified content services platform</div>
				</div>
				<div id='content-latest-news-updates'>
						<div id='latest-news-separator'></div>
						<div id="latest-news-header">Constituo 	
							<span id="latest-news-header-link">
								<a
									target="_blank"
									rel="noopener noreferrer"
									href="https://www.constituo.com/resources/newsroom/"
								>
									Newsroom <span className="fa fa-link-ext"></span>
								</a>
							</span></div>
						<div id="latest-news-blurb" readOnly tabIndex="0" role="textbox">Explore industry insights, product updates, press releases, and other news and information about how we help organizations integrate smarter and make decisions faster.</div>
				</div>
				
			</div>
			<div id='form-container'>
				<div id="login-form-upper-left-cloud">
				</div>
				<div id='inner-form-container'>
					<div id='login-application-logo'><span id="application-logo-wheel" className="fa fa-cs-logo"/><span id="login-application-name" className="ubuntu">content</span><span id='application-registered-mark' className='fa fa-trademark'></span></div>
					<form id='login-form' onSubmit={handleSubmit} aria-label="Login Form">
						<label htmlFor="username" className="login-label">Email</label>
						<input autoComplete="username" aria-label="username" tabIndex="1" type="text" name="username" id="username-input" className='login-field' onChange={e => setState({ ...state, username: e.target.value })} />
						<label htmlFor="password" className="login-label">Password</label>
						<input autoComplete="current-password" aria-label="password" tabIndex="2" type="password" name="password" id="password-input" className='login-field' onChange={e => setState({ ...state, password: e.target.value })} />
						<button aria-label="Sign In" tabIndex="3" type="submit" id="login-btn">Sign In</button>
						<div aria-label="Forgot Password" tabIndex="4" id="forgot_password" onClick={forgotPassword}>Forgot Password?</div>
						<div aria-label="Single Sign-On" tabIndex="5" id="custom-login-link" onClick={moveToCustomLogin}>Single Sign-On</div>
						<div id="prosecution">WARNING: Unauthorized access to this system is forbidden and will be prosecuted by law. By accessing this system, you agree that your actions may be monitored if unauthorized usage is suspected.</div>
					</form>
					<div id="copyright"><span className="fa fa-copyright"></span> <span className="copyright-year">{new Date().getFullYear()}</span> Constituo Software LLC. All rights reserved.</div>
				</div>
				<div id="login-form-lower-right-cloud">
				</div>
			</div>

			{state.masked && <LoadingPanel />}

			{state.error && (
				<MessageDialog 
					title={"Authentication Failed"}
					label={state.error} 
					closeCallback={() => setState({ ...state, error: false })}
				/>
			)}
			
			{state.dialog && (
				<MessageDialog
					title={state.dialog.title} 
					label={state.dialog.body}
					closeCallback={() => setState({ ...state, dialog: null })}
				/>
			)}
			
			{state.mfaDialog && (
				<MfaDialog 
					authenticatedCallback={authenticatedCallback}
					cancelCallback={closeDialog}
					loadPreferencesFromStateCallback={loadPreferencesFromState}
					mfaAuthorizeDeviceFailedCallback={mfaAuthorizeDeviceFailed}
					username={state.username}
				/>
			)}
			
		</div>
	);
}